import React, {Component} from 'react';
import {Button, Input} from 'semantic-ui-react'

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username: null,
      userpassword: null,
      userprofile: null,
      loginProcess : false,
      User: null
    };
  }

  componentDidMount() {

  }

  render() {
    const isLoading = this.state.loginProcess ? "loading" : "";
    if(this.state.User===null)
    return (
      <div>
        <Input name="username" placeholder='enter username'
               onChange={this.handleInputChange}/>
        <Input name="userpassword" placeholder='password' type="password"
               onChange={this.handleInputChange}/>
         <Button loading={isLoading} onClick={this.handleLoginClick} >Login</Button>
      </div>
    )
    else
      return(
        <div>
          {this.state.username}<br />
          <Button small onClick={this.handleLogoutClick}>Logout</Button>
        </div>
      )
  }

  handleInputChange = (event, data) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({[name]: value});
  }

  handleLoginClick = (e, {name}) => {
    if (this.state.username === null || this.state.userpassword === null)
      alert("Please enter user credentials before proceeding. Thanks.")
    else {
      this.validateUser()
    }
  }

  handleLogoutClick = (e, {name}) => {
    this.setState({User : null})
    window.location.reload();
  }

  validateUser() {
    this.setState({loginProcess : true });
    const User = this.getUser();
    var rp = require('request-promise');
    const requestData = {
      request: {
        "User": User,
      }
    }
    rp({
        url: window.globalAppTrackURL + "ValidateUser",
        method: "POST",
        headers: {"content-type": "application/json"},
        json: true,
        body: requestData
      }
    )
      .then(function (res) {return res})
      .catch(function (err) {return(err)})

      .then((json) => this.finishValidatingUser(json))
    return {apple:1}
  }

  finishValidatingUser(res) {
    this.setState({loginProcess : false });
    if(res.error) {
      alert("Unable to validate credentials");
    }
    else if(res.length===0) {
      alert("User not registered in the system, please review credentials");
    }
    else {
      //set User with user profile info
      this.setState({userprofile:res[0]["AcrisProfile"]})
      //Validate user against acris
      const oneCentreSt = {
        'BBL_BORO': '1',
        'BBL_BLOCK': '121',
        'BBL_LOT': '1',
      } //'1 CENTER ST, NEW YORK, NY 10001'
      this.validateAcrisUser(oneCentreSt)
    }
  }

  validateAcrisUser(argData) {
    this.setState({loginProcess : true });
    const User = this.getUser();
    var rp = require('request-promise');
    const requestData = {
      request: {
        "User": User,
        "addressData": argData,
      }
    }
    rp({
        url: window.globalAppTrackURL + "ValidateAddress",
        method: "POST",
        headers: {"content-type": "application/json"},
        json: true,
        body: requestData
      }
    )
      .then(function (res) {return res})
      .catch(function (err) {return(err)})

      .then((json) => this.finishValidatingAcrisUser(json))
    return {apple:1}
  }

  finishValidatingAcrisUser(res) {
    this.setState({loginProcess : false });
    if(res.error) {
      alert("Unable to login, please review credentials");
    }
    else
    {
      this.setState({User : this.getUser()})
      this.props.handleClick(this.state.User);
    }
  }

  getUser() {
    return(
      {
        "username" : this.state.username.toUpperCase(),
        "password" : this.state.userpassword,
        "userprofile" : this.state.userprofile
      }
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login.js